import React from 'react';

const ButtonRounded = ({ imgIcon, SvgIcon, label, action, isActive, showIndicator }) => (
  <div className={`App-button-rounded ${isActive ? 'active' : ''}`} onClick={action}>
    { imgIcon && <img src={imgIcon} alt="button icon" className="App-button-rounded-icon" /> }
    { SvgIcon && <SvgIcon className="App-button-rounded-icon" /> }
    { label && <p className="App-button-rounded-label">{label}</p> }
    { showIndicator && <div className="App-button-indicator"></div>}
  </div>
)

export default ButtonRounded;